export const sanity = {
  projectId: process.env.GATSBY_SANITY_ID || 'epgy3r3e',
  dataset: process.env.GATSBY_SANITY_DATASET || 'production',
}
